import { container, cardTitle, title } from 'assets/jss/material-kit-react.js'
import { primaryColor } from 'assets/jss/material-kit-react'

const casePageStyle = {
  container: {
    zIndex: '12',
    color: '#FFFFFF',
    ...container,
  },
  title: {
    ...title,
    display: 'inline-block',
    position: 'relative',
    marginTop: '30px',
    minHeight: '32px',
    color: '#FFFFFF',
    textDecoration: 'none',
  },
  subtitle: {
    ...title,
    display: 'inline-block',
    position: 'relative',
    marginTop: '-15px',
    color: '#FFFFFF',
    textDecoration: 'none',
    fontSize: '1.8rem',
    // maxWidth: '500px',
    // margin: '10px auto 0',
  },
  navButton: {
    color: 'inherit',
    '&:hover,&:focus': {
      color: 'inherit',
    },
  },
  main: {
    background: '#FFFFFF',
    position: 'relative',
    zIndex: '3',
  },
  mainRaised: {
    margin: '-60px 30px 0px',
    borderRadius: '6px',
    boxShadow: '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    '@media (max-width: 830px)': {
      'margin-left': '10px',
      'margin-right': '10px',
    },
    '@media (max-width: 576px)': {
      'margin-top': '-30px',
    },
  },
  section: {
    padding: '10px 0',
    textAlign: 'center',
  },
  titleIcon: {
    marginRight: '5px',
    fontSize: '2.25rem',
  },
  card: {
    transition: 'all 0.3s ease-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
    },
  },
  cardTitle: {
    ...cardTitle,
    color: 'white',
  },
  media: {
    height: '150px',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '4px 4px 0 0',
    backgroundColor: '#f5f5f5',
  },
  tagRibbon: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    backgroundColor: primaryColor,
    color: '#ffffff !important',
    padding: '0px 8px',
    filter: 'drop-shadow(2px 2px 2px rgba(0,0,0,0.6))',
    borderTopLeftRadius: 2,
    borderBottomLeftRadius: 2,
    '&:before, &:after': {
      position: 'absolute',
      right: -16,
      content: '" "',
      borderLeft: `16px solid ${primaryColor}`,
    },
    '&:before': {
      top: 0,
      borderBottom: '12px solid transparent',
    },
    '&:after': {
      bottom: 0,
      borderTop: '12px solid transparent',
    },
  },
  mediaTitle: {
    fontWeight: 900,
  },
  list: {
    padding: '0',
  },
  listItem: {
    padding: '0',
  },
  listText: {
    marginLeft: '-10px',
  },
  prizeIcon: {
    marginLeft: '-20px',
    width: '1px',
    height: '20px',
    padding: '0',
  },
  cardContent: {
    position: 'relative',
    zIndex: '2',
    minHeight: '280px',
    paddingTop: '60px',
    maxWidth: '440px',
    margin: '0 auto',
    color: 'white',
    fontWeight: '600',
  },
  cardHeader: {
    width: 'auto',
    textAlign: 'center',
    marginLeft: '20px',
    marginRight: '20px',
    marginTop: '-40px',
    padding: '20px 0',
    marginBottom: '15px',
  },
  cardFooter: {
    paddingTop: '0rem',
    border: '0',
    borderRadius: '6px',
    justifyContent: 'center !important',
  },
  // 图片加载相关样式
  loadingContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px 4px 0 0',
  },
  errorContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    color: '#999',
    fontSize: '14px',
    borderRadius: '4px 4px 0 0',
  },
  imageContainer: {
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    transition: 'opacity 0.3s ease-in-out',
  },
}

export default casePageStyle
